/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Menufiletoomany3Inputs */

const en_menufiletoomany3 = /** @type {(inputs: Menufiletoomany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`At most ${i?.count} files per reading.`)
};

const de_menufiletoomany3 = /** @type {(inputs: Menufiletoomany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Höchstens ${i?.count} Dateien pro Einlesen.`)
};

/**
* | output |
* | --- |
* | "At most {count} files per reading." |
*
* @param {Menufiletoomany3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menufiletoomany3 = /** @type {((inputs: Menufiletoomany3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menufiletoomany3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menufiletoomany3(inputs)
	return de_menufiletoomany3(inputs)
});
export { menufiletoomany3 as "menuFileTooMany" }